<template>
    <div class="bg-white text-center cursor-pointer hover:shadow h-full" @click="setElement">
        <img
            :src="item.bilde"
            class="w-full h-auto"
        />

        <div class="p-4">
            <h3 class="font-bold text-base">
                {{ item.navn }}
            </h3>
            <p>
                {{ item.antall }} tiltak
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['item', 'type'],
    methods: {
        setElement() {
            const data = {
                type: this.type,
                item: this.item
            };
            this.$emit('clicked', data);
        }
    }
};
</script>
